/* eslint-disable no-async-promise-executor */
/* eslint-disable @typescript-eslint/no-misused-promises */
import * as htmlToImage from 'html-to-image'
import defaultMovieImage from '../components/AnswerInput/MovieInput/no-movie.jpg'

export type Image = {
  source: string | null
  x: number
  y: number
  width: number
  height: number
  base64?: string
}

export const getBase64OfImage = async (image: Image): Promise<Image> => {
  const { source } = image
  return new Promise(async (resolve) => {
    if (source && (source.includes('https://cdn.') || source.includes('/src') || source.includes('/assets'))) {
      try {
        const response = await fetch(source)
        const blob = await response.blob()

        const extension = source.split('.').pop()
        const reader = new FileReader()
        reader.onloadend = function () {
          const base64Data = (reader.result as string).split(',')[1]
          const dataUrl = `data:image/${extension};base64,${base64Data}`
          resolve({
            ...image,
            base64: dataUrl,
          })
        }
        reader.readAsDataURL(blob)
      } catch (e) {
        // Do nothing
      }
    } else if (source && source.includes('base64')) {
      resolve({
        ...image,
        base64: source,
      })
    } else {
      resolve(image)
    }
  })
}

export const renderImage = async (
  canvas: HTMLCanvasElement,
  ctx: CanvasRenderingContext2D,
  svgWidth: number,
  svgHeight: number,
  image: Image,
) => {
  return new Promise((resolve) => {
    let { x, y, width, height } = image
    const { base64 } = image

    if (x > 0 && y > 0) {
      x = (canvas.width * x) / svgWidth
      y = (canvas.height * y) / svgHeight
      width = (canvas.width * width) / svgWidth
      height = (canvas.height * height) / svgHeight
    }

    const img = new Image()
    if (base64) {
      img.src = base64
    } else {
      resolve('No base 64')
    }
    img.onload = function () {
      ctx.drawImage(img, x, y, width, height)
      resolve('RENDERED')
    }

    img.onerror = function () {
      // Ignore on error to avoid fail request.
      resolve('ON ERROR')
    }
  })
}

export const renderCanvasToBase64 = (svg: HTMLElement): Promise<string> => {
  return new Promise(async (resolve) => {
    const box = svg.getAttribute('viewBox')
    const viewport = box?.split(/\s+|,/)
    const svgWidth = Number(viewport?.[2]) ?? 0
    const svgHeight = Number(viewport?.[3]) ?? 0
    const canvas = document.createElement('canvas')
    const svgString = new XMLSerializer().serializeToString(svg)
    const parser = new DOMParser()

    const svgDoc = parser.parseFromString(svgString, 'image/svg+xml')
    canvas.width = svgWidth
    canvas.height = svgHeight
    const images = Array.from(svgDoc.getElementsByTagName('image'))
      .map((image) => {
        let source = image.getAttributeNS('http://www.w3.org/1999/xlink', 'href')
        if (source?.includes('tmdb.org')) {
          source = defaultMovieImage
        }
        return {
          source: source,
          z: Number(image.getAttribute('z')) ?? 0,
          x: Number(image.getAttribute('x')) ?? 0,
          y: Number(image.getAttribute('y')) ?? 0,
          width: Number(image.getAttribute('width')) || svgWidth,
          height: Number(image.getAttribute('height')) || svgHeight,
        }
      })
      .sort((a, b) => a.z - b.z)

    const ctx = canvas.getContext('2d') as CanvasRenderingContext2D
    ctx.scale(1, 1)

    const promises = images.map((image) => getBase64OfImage(image))

    const imagesLoaded = await Promise.all(promises)

    for (let index = 0; index < imagesLoaded.length; index++) {
      const element = imagesLoaded[index]
      await renderImage(canvas, ctx, svgWidth, svgHeight, element)
    }

    // Now lets add bottom section
    const predictionBar = document.getElementById('PredictionBar')
    const predictionBarHeight = predictionBar?.clientHeight ?? 0
    const predictionBarWidth = predictionBar?.clientWidth ?? 0

    const dataUrl = await htmlToImage.toPng(predictionBar as HTMLElement)
    await renderImage(canvas, ctx, svgWidth, svgHeight, {
      source: dataUrl,
      base64: dataUrl,
      x: canvas.width - predictionBarWidth * 2 - 30,
      y: canvas.height - predictionBarHeight * 2 - 30,
      width: predictionBarWidth * 2,
      height: predictionBarHeight * 2,
    })

    canvas.toBlob(
      function (blob) {
        const reader = new FileReader()
        reader.readAsDataURL(blob as Blob)
        reader.onloadend = function () {
          const base64data = reader.result
          resolve(base64data as string)
        }
      },
      'image/png',
      1,
    )
  })
}

export const renderCanvasToBase64UsingBaseImage = (image: HTMLImageElement): Promise<string> => {
  return new Promise(async (resolve) => {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d') as CanvasRenderingContext2D
    ctx.scale(1, 1)
    canvas.width = 1200
    canvas.height = 1200

    const imageWithBase64 = await getBase64OfImage({
      source: image.src,
      x: 0,
      y: 0,
      width: 1200,
      height: 1200,
    })

    await renderImage(canvas, ctx, 1200, 1200, imageWithBase64)

    // Now lets add bottom section
    const predictionBar = document.getElementById('PredictionBar')
    const predictionBarHeight = predictionBar?.clientHeight ?? 0
    const predictionBarWidth = predictionBar?.clientWidth ?? 0

    const dataUrl = await htmlToImage.toPng(predictionBar as HTMLElement)
    await renderImage(canvas, ctx, 1200, 1200, {
      source: dataUrl,
      base64: dataUrl,
      x: canvas.width - predictionBarWidth * 2 - 30,
      y: canvas.height - predictionBarHeight * 2 - 30,
      width: predictionBarWidth * 2,
      height: predictionBarHeight * 2,
    })

    canvas.toBlob(
      function (blob) {
        const reader = new FileReader()
        reader.readAsDataURL(blob as Blob)
        reader.onloadend = function () {
          const base64data = reader.result
          resolve(base64data as string)
        }
      },
      'image/png',
      1,
    )
  })
}

